var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeReduced01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 184.44 133.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-13,.cls-26,.cls-41,.cls-5,.cls-6{fill:none;}.cls-2{isolation:isolate;}.cls-23,.cls-3,.cls-31{fill:#efeee8;}.cls-15,.cls-30,.cls-4{fill:#177ccd;}.cls-4{opacity:0.1;}.cls-5{stroke:#093f68;stroke-width:2px;}.cls-26,.cls-41,.cls-42,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-6{stroke:#70a040;stroke-width:2.83px;}.cls-7{fill:#70a040;}.cls-8{fill:#093f68;}.cls-9{fill:#085ca9;}.cls-10,.cls-35{fill:#2d183a;}.cls-11{fill:#93423a;}.cls-12{fill:#ab5143;}.cls-13,.cls-41{stroke:#2d183a;}.cls-13,.cls-29{stroke-linecap:round;stroke-linejoin:round;}.cls-13{stroke-width:0.28px;}.cls-14,.cls-18,.cls-36,.cls-37,.cls-38,.cls-40{mix-blend-mode:multiply;}.cls-14{opacity:0.46;}.cls-16{fill:#5a822b;}.cls-17,.cls-36,.cls-37{fill:#a2cb74;}.cls-18,.cls-31{opacity:0.43;}.cls-19{fill:#330d6e;}.cls-20{fill:#09324c;}.cls-21{fill:#fdfdfd;}.cls-22{clip-path:url(#clip-path);}.cls-23{opacity:0.13;}.cls-24{fill:#6d55b5;}.cls-25{fill:#381975;}.cls-26{stroke:#efeee8;}.cls-27{fill:#f7d65a;}.cls-28,.cls-29,.cls-42{fill:#f6b75a;}.cls-29,.cls-42{stroke:#f6b75a;}.cls-30,.cls-35,.cls-37,.cls-38{opacity:0.2;}.cls-32{fill:#f7b98f;}.cls-33{fill:#dd9872;}.cls-34{fill:#d18b69;}.cls-36{opacity:0.27;}.cls-38{fill:#db5b50;}.cls-39{fill:#cececc;}.cls-40{opacity:0.52;}.cls-41{stroke-width:0.85px;}.cls-42{stroke-width:0.57px;}.cls-43{opacity:0.32;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.86,133.45c0-.16.17-3-.79-3.39s-3.07-.61-3.7.38-.24,3.28-.24,3.28a17.87,17.87,0,0,0,2.36.28A8.25,8.25,0,0,0,43.86,133.45Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 87.74,
    cy: 51.62,
    r: 41.97,
    transform: "translate(22.77 129.99) rotate(-80.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.14,76.78a42,42,0,0,0,68.4-48.63S121,60.53,104.75,73.07C85.32,88.12,54.14,76.78,54.14,76.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 87.74,
    cy: 51.62,
    r: 41.97,
    transform: "translate(22.77 129.99) rotate(-80.81)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 107.09,
    y1: 20.76,
    x2: 104.75,
    y2: 24.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 69.47,
    y1: 79.8,
    x2: 67.34,
    y2: 83.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 119.5,
    y1: 33.91,
    x2: 115.91,
    y2: 35.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 58.36,
    y1: 68.08,
    x2: 54.94,
    y2: 69.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 119.73,
    y1: 69.58,
    x2: 115.9,
    y2: 67.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 58.19,
    y1: 36.2,
    x2: 54.71,
    y2: 34.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 107.48,
    y1: 82.88,
    x2: 105.23,
    y2: 79.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 69.1,
    y1: 24.29,
    x2: 66.95,
    y2: 21.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 87.22,
    cy: 17.87,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 87.42,
    cy: 86.03,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 121.4,
    cy: 51.85,
    r: 2.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 53.24,
    cy: 52.05,
    r: 2.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M86.09,50.62l29.82.58a.42.42,0,0,1,0,.84l-29.82.58a1,1,0,1,1,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M85.33,52.24,77.15,41.07a.44.44,0,0,1,.09-.59.43.43,0,0,1,.57.06L86.89,51a1,1,0,0,1-.09,1.41,1,1,0,0,1-1.42-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M30.84,105.31c.12,1.12,1.52,22.67,1.8,27a.79.79,0,0,0,.79.75h0a.8.8,0,0,0,.8-.79l.4-26.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82.42,106c-.12,1.11-1.51,22.67-1.79,27a.8.8,0,0,1-.8.74h0a.81.81,0,0,1-.8-.78l-.4-26.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 29.85,
    y: 103.6,
    width: 53.95,
    height: 3.43,
    rx: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M49.39,99.48s1.89,3.53,1,4.59-4.66,2.12-7.71,1.84-6.45-.89-7.18-2.36,2.19-4.49,2.19-4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.83,68.09s1.88-2,3.57-1.36,2,3,2,3,3.35-.45,3.67,1-2.13,3.66-2.13,3.66,1.74,1.52,1.22,2.94-4.33,1.49-4.33,1.49.49,1.3-.4,1.55-3.57-2.42-3.57-2.42-2.5,3.46-4.7,1.64,0-4.07,0-4.07-2.73.53-2.53-2,3.41-3,3.41-3-1.08-1.68-.3-2.27,1.94.2,1.94.2.58-1,1.1-1S42.83,68.09,42.83,68.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40.65,77.28V80a.34.34,0,0,1-.32.34l-1.08.08s1,3.46,2.76,3.72,4.39-3.35,4.39-3.35-1-.08-1.22-.47a11.09,11.09,0,0,1-.65-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M40.65,73.65s-.55-1.72-1.35-1.2c-1,.64.65,3,.65,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M46.73,74.63s1.36-1,1.62-.46S46,77.28,46,77.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M40.13,71.45s-.51,4.79,0,6.41a3.36,3.36,0,0,0,2.14,2.46c.91.39,3.36-1,4.4-3.75s1.36-5.37,1-6.22S40.13,71.45,40.13,71.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M44.5,73.18a1,1,0,0,1,.34.11,1.15,1.15,0,0,1,.28.19.87.87,0,0,1,.25.56.68.68,0,0,0-.4-.32.8.8,0,0,0-.44,0,.3.3,0,1,1-.24-.55.32.32,0,0,1,.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.47,73.45a.76.76,0,0,0-.4-.2.72.72,0,0,0-.49.13A.87.87,0,0,1,42,73a1.21,1.21,0,0,1,.33-.07,1.54,1.54,0,0,1,.36,0l0,0a.3.3,0,0,1,.22.36.31.31,0,0,1-.37.22A.39.39,0,0,1,42.47,73.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M41.34,74.18s.82-.19,1.15.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42.11,74.44c0,.14-.11.25-.22.24s-.18-.13-.17-.28.11-.26.22-.25A.24.24,0,0,1,42.11,74.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M44.12,74.71s.82-.17,1.13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M44.88,75c0,.15-.12.26-.23.24s-.18-.14-.16-.29.12-.25.23-.24A.25.25,0,0,1,44.88,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M43.26,78.4a.7.7,0,0,1-.4.13.82.82,0,0,1-.4-.1.67.67,0,0,1-.35-.74c.17,0,.26.1.36.13a1.11,1.11,0,0,1,.27.12,1.23,1.23,0,0,1,.25.17A2.67,2.67,0,0,1,43.26,78.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M42.11,79.07a.54.54,0,0,1,.24-.27.53.53,0,0,1,.32-.08.48.48,0,0,1,.46.48l-.31.07a.68.68,0,0,1-.2,0,1,1,0,0,1-.22-.06A2.3,2.3,0,0,1,42.11,79.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M43.22,74.52c.16.58.42,1,.58,1.55a3.2,3.2,0,0,1,.1.42,1.55,1.55,0,0,1,0,.21v.11A1.11,1.11,0,0,1,44,77c-.14.29-.29.23-.37.26a1,1,0,0,1-.25,0,1.54,1.54,0,0,1-.42-.17c.14-.07.28-.1.41-.16l.16-.07c.05,0,.06-.1,0,0s0,0,0,0l0-.1-.06-.19c0-.14-.08-.26-.11-.4a5.18,5.18,0,0,1-.16-.82A1.6,1.6,0,0,1,43.22,74.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M40,72.53a4,4,0,0,0,3.26-1.85s1.81,3.65,4.09,3.55l1.35-1.89-1.36-2.89H43.83l-3.18.69-.82,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M39.81,80.32A2.56,2.56,0,0,0,42,82.52c1.94.32,3.94-1.88,3.94-1.88s4.72,1.25,5.09,3.09c.46,2.27-.26,6.57-.26,6.57l-4.18-.14a31.43,31.43,0,0,0,.65,4.72c.32.65,2.2,4.6,2.2,4.6s-1.53,3-6.94,2.9c-4.83-.13-6.26-2-6.26-2s1.94-4.33,1.94-5.43.71-5.12.71-5.12l-3.76.24s-1.42-6.38.33-8.2C36.38,80.87,39.81,80.32,39.81,80.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M35.6,90l3.24-.21.45,3.82,1.36,6-1.88,1S36.7,96,36.7,93.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M49.91,90.3l-3.24-.21-.46,3.82-1.36,6,1.88,1s2.07-4.66,2.07-6.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 36.33,
    y: 100.11,
    width: 12.98,
    height: 1.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 36.33,
    y: 91.12,
    width: 12.98,
    height: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.43,95.77a1.6,1.6,0,1,1-1.6-1.59A1.6,1.6,0,0,1,44.43,95.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M38.55,85.85a3.31,3.31,0,0,1,.63,1.76,3.23,3.23,0,0,1-.37,1.83,3.48,3.48,0,0,1-.26-3.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M46.75,86.09a3.75,3.75,0,0,1-.2,3.74,3.46,3.46,0,0,1-.4-1.9A3.55,3.55,0,0,1,46.75,86.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M50.09,125.64s1.32-18.72,1.23-20.23c-.13-2.06-.25-4.32-4.77-4-3.18.25-2.75,4.41-2.46,7.36.12,1.29,2.37,17.54,2.37,17.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M39.4,126.05s-4.35-18.25-4.51-19.76c-.21-2.05-.45-4.3,4.06-4.68,3.18-.27,3.43,3.9,3.63,6.86.09,1.3.51,17.69.51,17.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M55.38,133.56l0-1.13a3.58,3.58,0,0,1-1.74.54c-1.32.18-2.26-.39-3.6-.57a22.66,22.66,0,0,0-2.78-.33c-.95,0-.79,0-.79,0v1a.18.18,0,0,0,.16.18c.42,0,1.12.12,2.22.22L49,133a.08.08,0,0,1,.15,0l.17.52.94.1c1.41.16,1.95.66,3.54.62a4,4,0,0,0,1.52-.45A.19.19,0,0,0,55.38,133.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46,126.05a6.13,6.13,0,0,1,.59,2.58,17.38,17.38,0,0,0-.15,2.54c0,.33,0,.9,0,.9s-.08.17.87.2a23.82,23.82,0,0,1,3,.28c1.34.18,1.83.67,3.34.42a4.08,4.08,0,0,0,1.74-.54s-.1-.91-.39-1.11a15.86,15.86,0,0,0-2.86-1.11c-1-.4-1.43-4.73-1.43-4.73s-3.57-.22-4.49.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M49.5,127.29a1.78,1.78,0,0,1,.38-.1l-.19,0h.12a.46.46,0,0,0,.28-.06.72.72,0,0,0,.37-.37.46.46,0,0,0,.06-.28l0-.18a.8.8,0,0,0-.19-.32l-.14-.11a.74.74,0,0,0-.36-.09,2.1,2.1,0,0,0-.43,0l-.25.08a.41.41,0,0,0-.24.13.52.52,0,0,0-.19.2.5.5,0,0,0-.08.26.53.53,0,0,0,0,.28l.07.17a.81.81,0,0,0,.26.26l.17.07a.77.77,0,0,0,.37,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M50.26,128.79l.09,0-.16.07a1.36,1.36,0,0,1,.36-.1.56.56,0,0,0,.24-.13.5.5,0,0,0,.18-.2.5.5,0,0,0,.08-.26.44.44,0,0,0,0-.28l-.07-.17a.78.78,0,0,0-.25-.26l-.17-.07a.81.81,0,0,0-.38,0,1.05,1.05,0,0,0-.24.06,3.2,3.2,0,0,0-.39.16.49.49,0,0,0-.2.18.55.55,0,0,0-.12.24.57.57,0,0,0,0,.29.51.51,0,0,0,.09.26l.11.14a.65.65,0,0,0,.31.18l.19,0a.65.65,0,0,0,.36-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M49.92,127.93l.1-.05-.17.07a2.42,2.42,0,0,1,.36-.1.55.55,0,0,0,.24-.12.61.61,0,0,0,.19-.2.5.5,0,0,0,.08-.27.54.54,0,0,0,0-.28l-.07-.17a.78.78,0,0,0-.26-.25l-.17-.07a.59.59,0,0,0-.37,0l-.24.05a3.52,3.52,0,0,0-.39.16.52.52,0,0,0-.2.19.56.56,0,0,0-.13.24.53.53,0,0,0,0,.28.47.47,0,0,0,.08.26l.11.15a.68.68,0,0,0,.32.18l.18,0a.88.88,0,0,0,.36-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M50.56,129.47l.13-.06-.16.07a.9.9,0,0,1,.32-.09.51.51,0,0,0,.24-.13.61.61,0,0,0,.19-.2.5.5,0,0,0,.08-.26.53.53,0,0,0,0-.28l-.07-.17a.81.81,0,0,0-.26-.26l-.17-.07a.77.77,0,0,0-.37,0,1,1,0,0,0-.25.06l-.27.11-.11.06a.44.44,0,0,0-.2.18.47.47,0,0,0-.13.24.53.53,0,0,0,0,.28.5.5,0,0,0,.08.27l.11.14a.65.65,0,0,0,.31.18l.19,0a.65.65,0,0,0,.36-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.33,130.57l.07-4.42a3.35,3.35,0,0,0-2.34-.39,6,6,0,0,0-2.45.71l1,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M43.86,133.45c0-.16.17-3-.79-3.39s-3.07-.61-3.7.38-.24,3.28-.24,3.28a17.87,17.87,0,0,0,2.36.28A8.25,8.25,0,0,0,43.86,133.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M44.1,131.73a3.78,3.78,0,0,1-2.28.9,9.06,9.06,0,0,1-3.2-.42s.3-2.1.38-2.17,3.19-.63,3.32-.74,1.43-.15,1.66.28A7.37,7.37,0,0,1,44.1,131.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.38,128.19a1,1,0,0,0-.5-.26l-.44-.06a2.26,2.26,0,0,0-.73.06.68.68,0,0,0-.42.32.51.51,0,0,0-.09.27.67.67,0,0,0,0,.28.73.73,0,0,0,.33.42.75.75,0,0,0,.55.07l.12,0-.19,0a2.44,2.44,0,0,1,.66,0l-.19,0,.13,0-.17-.08,0,0-.15-.11,0,0a.75.75,0,0,0,.51.21.66.66,0,0,0,.27-.06.57.57,0,0,0,.23-.15.73.73,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.2,127.36a1.36,1.36,0,0,0-.28-.11l-.32,0h-.35a6.11,6.11,0,0,0-.86.08.68.68,0,0,0-.43.33.78.78,0,0,0-.07.54.73.73,0,0,0,.33.42l.17.08a.81.81,0,0,0,.38,0l.09,0-.19,0a3.87,3.87,0,0,1,1,0l-.19,0,.14,0-.17-.07h0a.51.51,0,0,0,.26.09.66.66,0,0,0,.28,0,.76.76,0,0,0,.43-.33.74.74,0,0,0,.07-.55.69.69,0,0,0-.33-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.78,126.43a4,4,0,0,0-1.37.11.73.73,0,0,0-.42.33.68.68,0,0,0-.07.54.73.73,0,0,0,.32.43.8.8,0,0,0,.55.07,2.41,2.41,0,0,1,.37-.07l-.19,0a3.66,3.66,0,0,1,.81,0,.72.72,0,0,0,.5-.2.8.8,0,0,0,.21-.5.74.74,0,0,0-.21-.51l-.14-.11a.77.77,0,0,0-.36-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M45.71,59.17H30.4a.39.39,0,0,0-.34.42V62a.39.39,0,0,0,.34.43h.39a6.8,6.8,0,0,1-.17.9c-.07.24.16.43.32.28l1.26-1.18H45.71a.39.39,0,0,0,.35-.43V59.59A.39.39,0,0,0,45.71,59.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M45.77,44.39H30.46a.4.4,0,0,0-.35.43v2.41a.39.39,0,0,0,.35.43h.38a7.12,7.12,0,0,1-.17.9c-.07.23.16.43.32.28l1.26-1.18H45.77a.4.4,0,0,0,.35-.43V44.82A.4.4,0,0,0,45.77,44.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M20.62,51.29H35.93a.4.4,0,0,1,.35.43v3.69a.39.39,0,0,1-.35.42h-.39a7,7,0,0,0,.17.91c.07.23-.16.43-.32.28l-1.26-1.19H20.62a.39.39,0,0,1-.35-.42V51.72A.39.39,0,0,1,20.62,51.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 62.48,
    y: 91.58,
    width: 2.75,
    height: 12.22,
    transform: "translate(127.71 195.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M63.15,93.06a.71.71,0,1,0,.7-.7A.7.7,0,0,0,63.15,93.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 59.73,
    y: 91.58,
    width: 2.75,
    height: 12.22,
    transform: "translate(122.21 195.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M60.4,93.06a.71.71,0,0,0,.71.71.7.7,0,0,0,.7-.71.7.7,0,0,0-.7-.7A.7.7,0,0,0,60.4,93.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 56.99,
    y: 91.58,
    width: 2.75,
    height: 12.22,
    transform: "translate(116.72 195.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M57.66,93.06a.7.7,0,1,0,1.4,0,.7.7,0,0,0-1.4,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 54.24,
    y: 91.58,
    width: 2.75,
    height: 12.22,
    transform: "translate(111.22 195.38) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M54.91,93.06a.7.7,0,0,0,.7.71.71.71,0,0,0,.71-.71.7.7,0,0,0-.71-.7A.7.7,0,0,0,54.91,93.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 66.17,
    y: 91.31,
    width: 2.75,
    height: 12.22,
    transform: "translate(149.61 182.97) rotate(170.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M66.12,93a.7.7,0,1,0,1.39-.22.69.69,0,0,0-.8-.58A.7.7,0,0,0,66.12,93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M30.8,84.7V83.51h-.66a7.63,7.63,0,0,0-.17-.83l.61-.26-.46-1.1-.62.26a5.39,5.39,0,0,0-.43-.63l.47-.47-.84-.84-.47.47a4.6,4.6,0,0,0-.53-.37l.27-.61-1.08-.49-.27.61a5.21,5.21,0,0,0-.95-.21v-.66H24.48V79a6.57,6.57,0,0,0-.77.16l-.25-.62-1.1.45.25.61a6.45,6.45,0,0,0-.69.47l-.48-.47-.83.84.47.47a5.39,5.39,0,0,0-.43.63L20,81.32l-.46,1.09.61.26a5.68,5.68,0,0,0-.17.84h-.66V84.7H20a6,6,0,0,0,.17.84l-.61.26L20,86.89l.62-.26a4.38,4.38,0,0,0,.43.63l-.47.48.83.83.48-.47a4.6,4.6,0,0,0,.53.37l-.27.61,1.08.49.27-.61a5,5,0,0,0,.95.21v.66h1.19v-.66a5,5,0,0,0,.77-.16l.25.62,1.1-.45-.25-.61a5.25,5.25,0,0,0,.69-.47l.47.47.84-.83-.47-.48a5.39,5.39,0,0,0,.43-.63l.61.26.47-1.09L30,85.54a7.34,7.34,0,0,0,.17-.84Zm-5.73,1.52a2.12,2.12,0,1,1,2.12-2.11A2.1,2.1,0,0,1,25.07,86.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M33.9,93.21v-.72h-.4a4,4,0,0,0-.1-.5l.36-.16-.27-.65-.37.15c-.08-.13-.17-.26-.26-.38l.28-.29-.5-.5-.29.28a3.62,3.62,0,0,0-.32-.22l.16-.37-.65-.29-.16.36a5.78,5.78,0,0,0-.57-.12v-.4h-.72v.4a3.4,3.4,0,0,0-.46.09l-.15-.37-.67.27.16.37a3.07,3.07,0,0,0-.42.28l-.29-.28-.5.5L28,91c-.09.12-.18.25-.26.38l-.37-.16-.28.66.37.16a4,4,0,0,0-.1.5H27v.72h.4a2.77,2.77,0,0,0,.1.5l-.37.16.28.66.37-.16c.08.13.17.26.26.38l-.28.29.5.5.29-.28a3.62,3.62,0,0,0,.32.22l-.17.37.65.29.17-.36a2.62,2.62,0,0,0,.57.12v.4h.72v-.4a3.73,3.73,0,0,0,.46-.09l.15.37.66-.27-.15-.37a3.07,3.07,0,0,0,.42-.28l.29.28.5-.5-.28-.29a2.49,2.49,0,0,0,.25-.38l.37.16.28-.66-.37-.16a2.78,2.78,0,0,0,.11-.5Zm-3.45.92a1.28,1.28,0,1,1,1.27-1.28A1.28,1.28,0,0,1,30.45,94.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M26.54,95.59v-.71h-.41a2.77,2.77,0,0,0-.1-.5l.37-.16-.28-.66-.37.16a2.41,2.41,0,0,0-.26-.39l.29-.28-.51-.5-.28.28a3.62,3.62,0,0,0-.32-.22l.16-.37L24.18,92l-.16.36a2.85,2.85,0,0,0-.58-.12v-.4h-.71v.4a3.89,3.89,0,0,0-.47.09l-.15-.37-.66.27.15.37a3.07,3.07,0,0,0-.42.28l-.28-.28-.51.5.29.28a3.3,3.3,0,0,0-.26.39l-.37-.16-.28.66.37.15a3.06,3.06,0,0,0-.1.51h-.4v.71H20a2.71,2.71,0,0,0,.1.51l-.37.16.28.65.37-.15a3.19,3.19,0,0,0,.26.38l-.29.28.51.51.28-.28.33.22-.17.36.65.3.17-.37a3.39,3.39,0,0,0,.57.13v.4h.71v-.4a2.46,2.46,0,0,0,.47-.1l.15.38.66-.27-.15-.37a4.38,4.38,0,0,0,.42-.28l.28.28.51-.51-.29-.28a3.19,3.19,0,0,0,.26-.38l.37.15.28-.65L26,96.1a2.71,2.71,0,0,0,.1-.51Zm-3.45.92a1.28,1.28,0,1,1,1.27-1.27A1.27,1.27,0,0,1,23.09,96.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M29,24.58l-2,5.3a.42.42,0,0,0,.3.55l2.88.65a.42.42,0,0,1,.28.58l-1.93,4.06a.75.75,0,0,0,1.19.86l6.17-5.85a.41.41,0,0,0-.1-.67l-3.37-1.69a.41.41,0,0,1-.15-.61L34,25.34a.42.42,0,0,0-.3-.66l-4.32-.36A.43.43,0,0,0,29,24.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M36.65,34.94a.78.78,0,0,1,.92-.68.83.83,0,0,1-.28,1.63A.79.79,0,0,1,36.65,34.94Zm.66-1.83.9-6.36,1.27.22-1.28,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M113.43,102.44a5.75,5.75,0,0,0-5.78,5.72,5.67,5.67,0,0,0,.73,2.77,9.45,9.45,0,0,1-2.06,1.35.42.42,0,0,0,0,.75,5.42,5.42,0,0,0,4-.07,5.74,5.74,0,1,0,3.13-10.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M103.58,97.07a.27.27,0,0,1,.23.42c-.84,1.2-2,3.88-3.56,5.6-.91,1-1.53,8-1.55,10.16,0,4.37-.51,7.22-.24,10.77.19,2.49,7.89,3.75,9.13,3.94a.27.27,0,0,1,.22.19l.37,1.27a.27.27,0,0,1-.26.34H87.11a.27.27,0,0,1-.26-.34l.37-1.27a.28.28,0,0,1,.22-.19c1.25-.19,8.94-1.45,9.13-3.94.27-3.55-.1-6.94-.18-10.86,0-2.18-.78-9.11-1.7-10.07-1.54-1.6-2.62-4.4-3.46-5.6a.26.26,0,0,1,.22-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M100.63,109.9v-.47a11.18,11.18,0,0,1,2.53-7c3-3.73,6-9.7,6-14.58H85.9c0,4.88,3,10.91,6.11,14.67a11.18,11.18,0,0,1,2.55,7.06v.25A11.18,11.18,0,0,1,92,116.85c-3.06,3.76-6.11,9.79-6.11,14.68h23.24c0-4.89-3-10.85-6-14.59A11.18,11.18,0,0,1,100.63,109.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 83.79,
    y: 86.02,
    width: 27.5,
    height: 2.78,
    rx: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 83.79,
    y: 130.47,
    width: 27.5,
    height: 2.78,
    rx: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M89.93,91.31c-.42-.79-1.05-1.68-1.81-1.63s-1,1.08-.63,2.43c.59,2,2.22,6.74,5.25,9.41C94.17,102.78,96.4,99.65,94,98,91.27,96,89.93,91.31,89.93,91.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M88.21,128.28c-.24-2.92.73-6.28,5.08-10.54,2.14-2.1,2.27,1.26-.46,4.49-2.16,2.56-1.55,4.45-1.89,5.84C90.73,128.92,88.35,130.11,88.21,128.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M111.9,110.93a.49.49,0,0,1,.5-.52.53.53,0,0,1,0,1A.5.5,0,0,1,111.9,110.93Zm.22-1.21-.1-4.07h.81l-.14,4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M114.08,110.93a.49.49,0,0,1,.5-.52.53.53,0,0,1,0,1A.49.49,0,0,1,114.08,110.93Zm.22-1.21-.1-4.07H115l-.14,4.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "134.79 100.85 135.03 102.16 132.81 102.16 132.35 100.94 134.79 100.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "139.21 101.04 139.09 102.84 136.94 102.84 136.67 101.04 139.21 101.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.41,103.86s-.1-2.22-1.47-2.22c-1.75,0-1.78,2.22-1.78,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135,101.63l.33,2c0,.18-.11.31-.53.31h-5.71a.2.2,0,0,1-.08-.39l3.75-1.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "135.69 45.23 136.16 41.96 139.66 41.01 139.19 45.52 138.86 47.56 134.88 46.38 135.69 45.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M139.86,41.63s-1.57,2.9-4.38,2.08c-2-.57-1.91-3.32-1.41-6,.78-4.16,2.22-4.17,4.33-3.6C143.18,35.4,139.86,41.63,139.86,41.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M142.44,68.58a43.44,43.44,0,0,1,.17,5c-.31,7-3.27,27.71-3.27,27.71h-2.86s-.68-13.09-.62-14.36-.13-12.66-.13-12.66l-2,11.47L135,101.28h-2.61l-4.23-14.06a2.76,2.76,0,0,1-.11-1.14L130,68.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M126.54,48.81l-7.32-4.52s7.42.18,9.93.18a52.09,52.09,0,0,1,6.54.76s.23,1.32,1.32,1.43,2.18-1.14,2.18-1.14,4.92.84,5.81,3.44a26.59,26.59,0,0,1,1.25,5.64l-3.55,1s-.4,3.31-.4,4.88.14,8.32.14,8.32a21,21,0,0,1-5.9,1,42.09,42.09,0,0,1-6.6-.59s.76-10.64.73-12.32c0-.87-.12-2-.21-2.85s-.17-5.12-.17-5.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M113.74,47.36l-3.2,1.72-3.11.18-2.18,1.35c-.1.06.13.33.45.25l1.79-.61,1.76.14s-.09.48-.16.52c-.52.33-1.46.09-1.51.46s1.1.41,1.83.17a11.59,11.59,0,0,0,2-.93l3.31-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M135.4,38.1c0,.27,0,.51.2.53s.3-.18.34-.46-.05-.51-.2-.53S135.44,37.82,135.4,38.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M137.41,38.36c0,.28.05.52.2.54s.29-.19.33-.46-.05-.52-.19-.54S137.45,38.09,137.41,38.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M135.85,37.2a.61.61,0,0,0-.79.1.7.7,0,0,1,.3-.46,1,1,0,0,1,.28-.14,1.08,1.08,0,0,1,.33-.06H136a.31.31,0,0,1,0,.62A.35.35,0,0,1,135.85,37.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M137.73,36.88a.83.83,0,0,1,.3.14.74.74,0,0,1,.23.2.69.69,0,0,1,.17.53.58.58,0,0,0-.34-.3.65.65,0,0,0-.39,0,.3.3,0,0,1-.4-.17.32.32,0,0,1,.17-.4.34.34,0,0,1,.2,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M136.77,38.23a1.35,1.35,0,0,1-.07.82,4.8,4.8,0,0,1-.35.68c-.06.11-.14.21-.2.31l-.11.15,0,.08s0,.09,0,0-.07-.08,0-.07a.65.65,0,0,0,.12.11l.31.26a1.47,1.47,0,0,1-.42.05.93.93,0,0,1-.22,0c-.06,0-.22,0-.27-.34a.52.52,0,0,1,.06-.2l0-.09a1.42,1.42,0,0,1,.08-.18,3.62,3.62,0,0,1,.2-.33C136.13,39,136.47,38.68,136.77,38.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M140.64,35.34s.67-.06.8.78a8.78,8.78,0,0,1-1.91,6.15l.65-4.19a2.25,2.25,0,0,1-.75-2.35C139.52,35.43,140.64,35.34,140.64,35.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M140.22,38.56l-.35,1.77a.23.23,0,0,1-.29.2l-.29-.08a.22.22,0,0,1-.16-.27l.71-3.28.7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M138.65,34.21c1.57.61,1.73,1.38,1.73,1.38l-.86.36c-.18,0-4.71,2.34-5.38-1.88l.46.3a5,5,0,0,0,2.53.25C137.92,34.39,138.65,34.21,138.65,34.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M139.2,40.22a7.59,7.59,0,0,1-3,.61,4.37,4.37,0,0,1-2.44-.68s-.36,3.41,2.17,3.67,3.66-2,3.88-3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.18,41.56s1.47,1.75,2.08-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M139.66,40.68l.3-2.07s1.15.18,1.29.89S141,41,139.66,40.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M140.15,39.11a.56.56,0,0,1,.41-.07.63.63,0,0,1,.38.19.55.55,0,0,1,0,.81c-.11-.12-.17-.2-.24-.26l-.16-.16a1.93,1.93,0,0,1-.17-.2A2.7,2.7,0,0,1,140.15,39.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M140.76,39.46a1.07,1.07,0,0,1-.08.28.38.38,0,0,1-.09.14c-.07.07-.14,0-.37.16a.36.36,0,0,1,0-.57.38.38,0,0,1,.25-.11A.43.43,0,0,1,140.76,39.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M128.53,45s-8.59-.81-9.31-.7a54,54,0,0,0-5.59,3.13l.9,2L119,47.82l7.54,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M141.47,67l-1,3.08a7.45,7.45,0,0,0-2.05,3.23.17.17,0,0,0,.28.16c.21-.19.59-.73.65-.78s-1,3.4-.81,3.42c.41,0,1.43-3,1.43-3s-.69,3.33-.36,3.33a23.91,23.91,0,0,0,1.19-3.16s-.4,3,0,3a18.81,18.81,0,0,0,.74-2.91s-.22,2.36.14,2.33c.17,0,.93-5.09.93-5.09l.78-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M146.25,54.55v6.2a2.19,2.19,0,0,1-.2,1.21l-2.65,6.66-2.23-1.14,1.8-6.13-.78-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M134.88,44.8a2.14,2.14,0,0,0,.69-.31.17.17,0,0,1,.18,0,6.33,6.33,0,0,0,.89.28,5.38,5.38,0,0,0,2.7-.28s.36.91.76,1.12-.76,1.08-.76,1.08l-1.31.7-.9.1a2.85,2.85,0,0,0-.51,0c-.09,0-.65-.08-.71-.2s-.69-.75-.73-.88a6,6,0,0,1-.39-1A3.18,3.18,0,0,1,134.88,44.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M142,53.57s.69,5.48.61,6.3-1.75,5.17-1.69,6.24,1.92,2.23,3.22,1.71,2.34-4.73,2.59-8-1.39-11.16-1.89-12.25-4.17-1.67-4.64-2-2,1.28-3.21,1.06-2.13-1.86-2.13-1.86-3-.28-4-.52-9-.36-10.91-.44a8.3,8.3,0,0,0-4.76,1.83c-.79.63.25,2.78,1.16,3.34s3.18-.84,4.13-.76,8.43.71,9.12,1.53.57,13.43,0,15.32-.69,3,.82,3.52,10.56-.2,10.56-.2l1.36-4.89L143,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M116.41,49c.91.57,3.18-.84,4.13-.76s8.43.71,9.12,1.53c0,0,.24-.27-1.3-.76s-7.05-1.5-8-1.32-2.21.94-2.91,1A2.89,2.89,0,0,0,116.41,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M138.31,68.62l2.73-.2.36-1.36a1.52,1.52,0,0,1-.51-1c0-.72,1.74-6.21,1.74-6.21l-.61-6.3s.23,5.13-.29,7.23S138.31,68.62,138.31,68.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M142.08,67.56a3.19,3.19,0,0,0,1.91.31c.73-.25,1.28-1.45,1.28-1.45s-.94,1.22-1.59,1.22S142.08,67.56,142.08,67.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M134.88,34.71s.36-1.15,1.34-1.15a9.06,9.06,0,0,1,3.79,1,1.62,1.62,0,0,1,.37,1.3s-2.78-.52-3-.48A23.14,23.14,0,0,1,134.88,34.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 123.54,
    y: 103.86,
    width: 23.09,
    height: 29.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M123.54,103.86s24.89-1.65,27.78-4.51c0,0-1.88,4.15-4.69,4.51S123.54,103.86,123.54,103.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "124.71 115.65 121.27 117.69 126.59 118.16 124.71 115.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "143.34 125.36 149.13 126.45 144.36 127.55 143.34 125.36"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.87,104.38a102.16,102.16,0,0,1,20.19,0,87.47,87.47,0,0,1-10.1.5A87.41,87.41,0,0,1,124.87,104.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.87,105.68a87.58,87.58,0,0,1,10.1-.5,87.41,87.41,0,0,1,10.09.5,92.13,92.13,0,0,1-10.09.5A92.31,92.31,0,0,1,124.87,105.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.88,107a89.71,89.71,0,0,1,10.09-.5,87.58,87.58,0,0,1,10.1.5,92.31,92.31,0,0,1-10.1.5A92.13,92.13,0,0,1,124.88,107Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.88,108.26a102.16,102.16,0,0,1,20.19,0,87.47,87.47,0,0,1-10.1.5A92.13,92.13,0,0,1,124.88,108.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.88,109.55a102.16,102.16,0,0,1,20.19,0,87.41,87.41,0,0,1-10.09.5A87.58,87.58,0,0,1,124.88,109.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.88,110.85a87.69,87.69,0,0,1,10.1-.5,87.58,87.58,0,0,1,10.1.5,102.26,102.26,0,0,1-20.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.89,112.14a92.13,92.13,0,0,1,10.09-.5,87.58,87.58,0,0,1,10.1.5,87.58,87.58,0,0,1-10.1.5A92.13,92.13,0,0,1,124.89,112.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.89,113.43a102.16,102.16,0,0,1,20.19,0,87.41,87.41,0,0,1-10.09.5A87.58,87.58,0,0,1,124.89,113.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.89,114.72a90,90,0,0,1,10.1-.49,89.87,89.87,0,0,1,10.1.49,87.58,87.58,0,0,1-10.1.5A87.69,87.69,0,0,1,124.89,114.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.9,116a87.41,87.41,0,0,1,10.09-.5,87.58,87.58,0,0,1,10.1.5,102.16,102.16,0,0,1-20.19,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.9,117.31a92.31,92.31,0,0,1,10.1-.5,87.41,87.41,0,0,1,10.09.5,87.41,87.41,0,0,1-10.09.5A92.31,92.31,0,0,1,124.9,117.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.9,118.6a102.26,102.26,0,0,1,20.2,0,87.58,87.58,0,0,1-10.1.5A87.58,87.58,0,0,1,124.9,118.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.91,119.9a87.41,87.41,0,0,1,10.09-.5,87.58,87.58,0,0,1,10.1.5,102.16,102.16,0,0,1-20.19,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.91,121.19a92.31,92.31,0,0,1,10.1-.5,87.41,87.41,0,0,1,10.09.5,102.16,102.16,0,0,1-20.19,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.91,122.48a102.26,102.26,0,0,1,20.2,0,87.58,87.58,0,0,1-10.1.5A89.88,89.88,0,0,1,124.91,122.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.92,123.77a102.16,102.16,0,0,1,20.19,0,87.58,87.58,0,0,1-10.1.5A87.41,87.41,0,0,1,124.92,123.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.92,125.07a87.58,87.58,0,0,1,10.1-.5,87.41,87.41,0,0,1,10.09.5,102.16,102.16,0,0,1-20.19,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.92,126.36a92.31,92.31,0,0,1,10.1-.5,87.69,87.69,0,0,1,10.1.5,87.69,87.69,0,0,1-10.1.5A92.31,92.31,0,0,1,124.92,126.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.93,127.65a102.16,102.16,0,0,1,20.19,0,87.58,87.58,0,0,1-10.1.5A87.41,87.41,0,0,1,124.93,127.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.93,129a87.58,87.58,0,0,1,10.1-.5,87.41,87.41,0,0,1,10.09.5,102.16,102.16,0,0,1-20.19,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.93,130.24a89.88,89.88,0,0,1,10.1-.5,87.69,87.69,0,0,1,10.1.5,102.26,102.26,0,0,1-20.2,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M124.94,131.53a102.16,102.16,0,0,1,20.19,0,87.58,87.58,0,0,1-10.1.5A92.13,92.13,0,0,1,124.94,131.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M53.14,20.4l.93.74.42-.52a5.34,5.34,0,0,0,.75.39l-.18.64,1.15.32.18-.64a4.87,4.87,0,0,0,.76.06l.08.66,1.18-.13-.08-.66a4.44,4.44,0,0,0,.62-.19l.31.6,1.06-.54L60,20.54a5.57,5.57,0,0,0,.76-.62l.52.42.74-.93L61.51,19a5.15,5.15,0,0,0,.36-.7l.64.19.34-1.14-.64-.19a4.57,4.57,0,0,0,.07-.83l.66-.08-.13-1.17-.66.07a4.75,4.75,0,0,0-.23-.73l.59-.32-.56-1-.59.31a4.85,4.85,0,0,0-.55-.65l.42-.52-.93-.75-.42.52a5.34,5.34,0,0,0-.75-.39l.18-.64-1.15-.32-.18.64a4.87,4.87,0,0,0-.76-.06l-.08-.66L56,10.67l.08.66a4.44,4.44,0,0,0-.62.19l-.31-.6-1,.54.3.59a4.94,4.94,0,0,0-.75.62l-.53-.42-.74.93.52.42a4.52,4.52,0,0,0-.36.69l-.64-.19-.33,1.14.63.19a4.65,4.65,0,0,0-.07.83l-.66.08.13,1.18.66-.08a4.43,4.43,0,0,0,.23.73l-.59.32.57,1.05.58-.32a5.66,5.66,0,0,0,.55.66ZM55.53,15a2.12,2.12,0,1,1,.33,3A2.13,2.13,0,0,1,55.53,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44.56,17.5l.56.44.25-.31a2.82,2.82,0,0,0,.46.23l-.11.39.69.19.11-.38a3.55,3.55,0,0,0,.46,0l0,.4.71-.07,0-.4a2.78,2.78,0,0,0,.38-.12l.18.36.63-.32-.18-.36a3.92,3.92,0,0,0,.46-.37l.31.25.45-.56-.32-.25a2.1,2.1,0,0,0,.22-.42l.39.12.2-.69L50,15.55a4.38,4.38,0,0,0,0-.5l.4-.05-.08-.71-.4.05a3.88,3.88,0,0,0-.14-.45l.36-.19-.34-.63-.36.2a2.06,2.06,0,0,0-.33-.4l.25-.31-.55-.45-.25.31a2.82,2.82,0,0,0-.46-.23l.11-.39-.69-.19-.11.39A2.38,2.38,0,0,0,47,12l-.05-.4-.71.08.05.4a2.72,2.72,0,0,0-.38.11l-.18-.36-.64.33.19.35a3.24,3.24,0,0,0-.46.37l-.31-.25-.45.56.32.25a2.82,2.82,0,0,0-.22.42l-.39-.12-.2.69.38.11a2.92,2.92,0,0,0,0,.51l-.4,0,.08.71.4,0a2.49,2.49,0,0,0,.14.44l-.36.19.34.63.35-.19a2.5,2.5,0,0,0,.34.39ZM46,14.23A1.28,1.28,0,1,1,46.2,16,1.28,1.28,0,0,1,46,14.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.3,10.26l.56.44.25-.31a2.82,2.82,0,0,0,.46.23l-.11.39.69.19.11-.38.46,0,0,.39.71-.07,0-.4a2.29,2.29,0,0,0,.37-.12L51,11l.63-.32-.18-.36a3.16,3.16,0,0,0,.45-.37l.32.25.44-.56-.31-.25A2.1,2.1,0,0,0,52.56,9l.38.12.21-.69-.39-.11a2.92,2.92,0,0,0,.05-.5l.4,0-.08-.71-.4,0a3.88,3.88,0,0,0-.14-.45l.35-.19-.33-.62L52.25,6a3.19,3.19,0,0,0-.33-.4l.25-.31-.55-.45-.26.31A2.73,2.73,0,0,0,50.91,5L51,4.56l-.69-.19-.11.39a2.38,2.38,0,0,0-.46,0l0-.4L49,4.4l0,.4a2.72,2.72,0,0,0-.38.11l-.18-.36-.64.33.18.35a3.16,3.16,0,0,0-.45.37l-.31-.25-.45.56.31.25a4.11,4.11,0,0,0-.21.42l-.39-.12-.2.69.38.11a2.92,2.92,0,0,0,0,.51l-.4,0,.08.71.4,0a2.49,2.49,0,0,0,.14.44l-.36.19.34.63.35-.19a3.09,3.09,0,0,0,.33.39ZM48.74,7a1.28,1.28,0,0,1,1.8-.2,1.28,1.28,0,1,1-1.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M141.75,20.06a23.47,23.47,0,0,0-1.69-2.71,6.12,6.12,0,0,1-1.13-1.87,2.43,2.43,0,0,1-.05-1.1.65.65,0,0,1,.61-.57c.32,0,.63.37.83.74a1,1,0,0,1,.16.47c0,.17-.08.32-.22.3a.34.34,0,0,1-.17-.13,1.24,1.24,0,0,1,0-1.39.88.88,0,0,1,1.6,0,1,1,0,0,1,0,1.07.93.93,0,0,1-.41-1.05c.37-1.25,1.35-.47,1.58.21a14,14,0,0,1,.3,2.43c.14,1,.42,1.94.53,2.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M139.09,9.38a3.55,3.55,0,0,0-2.56,4.28c.61,1.83,3,3.57,3.48,5l.51,1.54,3.88-1.28-.51-1.55c-.47-1.46.41-4.26-.2-6.1A3.54,3.54,0,0,0,139.09,9.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M145.53,22.31a11.26,11.26,0,0,1-1.87.88,12.68,12.68,0,0,1-2,.41.34.34,0,0,1-.43-.22l-1.05-3.17a.34.34,0,0,1,.22-.43,6.79,6.79,0,0,0,2-.41c1-.46,1.88-.88,1.88-.88a.34.34,0,0,1,.43.22l1.05,3.17A.34.34,0,0,1,145.53,22.31Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M140.91,20.45a7.86,7.86,0,0,1,1.75-.79,15,15,0,0,1,1.84-.4,1.59,1.59,0,0,1-.63.88,2.7,2.7,0,0,1-.92.48,3.12,3.12,0,0,1-1,.13A1.87,1.87,0,0,1,140.91,20.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M141.08,21.47a7.86,7.86,0,0,1,1.75-.79,13.11,13.11,0,0,1,1.84-.39,1.7,1.7,0,0,1-.63.87,2.9,2.9,0,0,1-.92.48,3.18,3.18,0,0,1-1,.13A1.86,1.86,0,0,1,141.08,21.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M141.41,22.5a7.8,7.8,0,0,1,1.75-.79,13.52,13.52,0,0,1,1.85-.4,1.73,1.73,0,0,1-.63.88,3,3,0,0,1-.93.48,3.37,3.37,0,0,1-1,.13A2,2,0,0,1,141.41,22.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139,10.83a.36.36,0,0,0-.33-.43,1,1,0,0,0-.59.17,2.53,2.53,0,0,0-.6.43,2,2,0,0,0-.56,1.32,2.57,2.57,0,0,0,.23,1.45.53.53,0,0,0,1-.33c0-.76-.75-1-.06-1.52A3.05,3.05,0,0,0,139,10.83Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "142.94 8.24 144.03 4.7 146.02 6.2 143.66 8.77 142.94 8.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "143.98 9.16 146.69 8.14 147.08 9.94 144.4 9.94 143.98 9.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "142.14 8.14 141.25 8.14 140.4 5.57 142.33 5.57 142.14 8.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M124.46,12.61l-.6.61.35.33a4.21,4.21,0,0,0-.34.52l-.44-.18-.32.8.45.17a3.33,3.33,0,0,0-.1.55H123v.85h.48a3.73,3.73,0,0,0,.09.46l-.45.17.31.8.44-.18a3.76,3.76,0,0,0,.39.59l-.34.34.61.6.33-.35a3,3,0,0,0,.48.31l-.19.45.79.32.18-.44a4.21,4.21,0,0,0,.6.11v.48h.85v-.48a3.45,3.45,0,0,0,.54-.11l.18.45.79-.33-.18-.44a5.16,5.16,0,0,0,.51-.35l.34.34.6-.61L130,18a3.48,3.48,0,0,0,.34-.51l.44.18.32-.8-.45-.17a3.33,3.33,0,0,0,.1-.55h.48v-.85h-.48a3.73,3.73,0,0,0-.09-.46l.45-.17-.31-.8-.44.18a3.76,3.76,0,0,0-.39-.59l.34-.34-.61-.6-.34.35a2.94,2.94,0,0,0-.47-.31l.19-.45-.79-.32-.18.44a4.21,4.21,0,0,0-.6-.11v-.48h-.85v.48a3.45,3.45,0,0,0-.54.11l-.18-.45-.79.33.18.44a4.2,4.2,0,0,0-.51.35Zm3.71,2.1a1.53,1.53,0,1,1-2.16,0A1.53,1.53,0,0,1,128.17,14.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M132.73,17.83l-.5.51.28.28a4,4,0,0,0-.28.43l-.37-.14-.26.66.37.15a3.54,3.54,0,0,0-.08.45h-.4v.71h.41a2.53,2.53,0,0,0,.07.38l-.38.15.26.66.38-.14a2.94,2.94,0,0,0,.32.49l-.28.28.51.5.28-.28a3.3,3.3,0,0,0,.39.26l-.15.37.66.27.15-.37a2.19,2.19,0,0,0,.5.09V24h.72v-.4a3.4,3.4,0,0,0,.46-.09l.15.37.66-.28-.15-.37a2.42,2.42,0,0,0,.42-.29l.29.28.5-.5-.28-.29a3.18,3.18,0,0,0,.28-.43l.37.15.26-.67-.37-.14a3.4,3.4,0,0,0,.08-.46h.4v-.72H138a2.66,2.66,0,0,0-.07-.39l.38-.14-.26-.67-.38.15a2.58,2.58,0,0,0-.32-.49l.28-.29-.51-.5-.28.29a2.41,2.41,0,0,0-.39-.26l.15-.37-.66-.27-.15.37a3,3,0,0,0-.5-.1v-.4h-.72v.4a3.4,3.4,0,0,0-.46.09l-.15-.37-.66.27.15.37a3.13,3.13,0,0,0-.42.29Zm3.1,1.76a1.27,1.27,0,1,1-1.8,0A1.28,1.28,0,0,1,135.83,19.59Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeReduced01);
export default __webpack_public_path__ + "static/media/TimeReduced-01.220ebd37d74ca8a16724726a792c5309.svg";
export { ForwardRef as ReactComponent };